import { Box, Label } from "@primer/react";
import { useMemo } from "react";

interface IDiemDanhStatusProps {
    name: string,
    id: number
}

const DiemDanhStatus = (props: IDiemDanhStatusProps) => {
    const variant = useMemo(() => {
        if (props.id === 0) return "attention";
        if (props.id === 1) return "success";
        if (props.id === 2 || props.id === 5) return "accent";
        if (props.id === 3) return "done";
        if (props.id === 4) return "danger";
        if (props.id === 6) return "danger";
        return "default";
    }, [props.id])
    return (
        <Box>
            {props.name &&
                <Label variant={variant} size="small">{props.name}</Label>
            }
        </Box>
    );
};

export default DiemDanhStatus;